/* First product (18 Oct 2026). A collection link carrying ?first=<variant id> (the catalogue ads'
   link) shows that shirt first, in the tapped colour; the page is unchanged without it.
   Card markup comes from sections/first-card.liquid; undo = remove the script tag at the foot of
   sections/main-collection-product-grid.liquid. */
(function () {
  var q = new URLSearchParams(location.search);
  var id = q.get('first');
  if (!id || !/^\d+$/.test(id) || (q.get('page') && q.get('page') !== '1')) return;
  var grid = document.getElementById('product-grid-ajax');
  if (!grid) return;
  fetch('/variants/' + id, { redirect: 'follow', credentials: 'same-origin' })
    .then(function (r) {
      var m = new URL(r.url).pathname.match(/\/products\/([^\/?#]+)/);
      if (!r.ok || !m) throw new Error('no product');
      return m[1];
    })
    .then(function (handle) {
      return fetch('/products/' + handle + '?variant=' + id + '&section_id=first-card')
        .then(function (r) { if (!r.ok) throw new Error('no card'); return r.text(); })
        .then(function (html) { return { handle: handle, html: html }; });
    })
    .then(function (res) {
      var box = document.createElement('div');
      box.innerHTML = res.html;
      var card = box.querySelector('.card--product');
      if (!card) return;
      grid.querySelectorAll('.card--product').forEach(function (c) {
        var a = c.querySelector('a[href]');
        if (a && a.getAttribute('href').split('?')[0].replace(/\/$/, '').endsWith('/products/' + res.handle)) c.remove();
      });
      grid.insertBefore(card, grid.firstElementChild);
    })
    .catch(function () {});
})();
